import React from 'react';
import { useHistory } from 'react-router';

import { Container } from './styles';

function BannerVideo({ title, action, videoSrc }) {
  const { push } = useHistory();

  const handleItemClick = to => {
    push(to);
  };
  return (
    <Container>
      <div className="info">
        <h3 className="info__title">{title}</h3>

        <button
          className="info__button"
          onClick={() => handleItemClick(action.to)}
        >
          {action.buttonText}
        </button>
      </div>
      <div className="video">
        <iframe src={videoSrc}></iframe>
      </div>
    </Container>
  );
}

export default BannerVideo;
